import styled from '@emotion/styled';

import { Snackbar, theme } from '@ublend-npm/aulaui-next';

export const StyledSnackbar = styled(Snackbar)`
  button[type='button'] {
    color: ${theme.color.greenDark};
  }
`;

export default {
  StyledSnackbar,
};
